// import { takeEvery } from 'redux-saga/effects'
// import { products as actions } from 'flux/actions'
// import { products as api } from 'flux/api'

export default function* () {
  // yield takeEvery(actions.types.SOMETHING, doSomething)
}
